
import api from '@/api'
import { _types } from './constant'

const state = {
};

const getters = {
};

const actions = {
  async [_types.actions.GET_BANNER_ONECOMMERCES]({}, payload){
    try {
      return await api.getBannerOneCommerces(payload)
    } catch (error) {
      throw error;
    }
  },
  async [_types.actions.CHECK_ONECOMMERCES_CODE]({}, payload) {
    try {
      return await api.checkOnecommercesCode(payload);
    } catch (error) {
      throw error;
    }
  }
};

const mutations = {
};
export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
};